import React from 'react'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {Box} from '@vio/atlas/helpers/Box'
import {Tag} from '@vio/atlas/Tag'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {PriceComposition} from '../../../search/PriceComposition/PriceComposition'
import {DEAL_FREEZE_OFFER_BOX_CARD} from './constants'
import {dealFreezeOfferBoxMessages} from './messages'
import {FromPrice} from './types'

const Card = styled(Box)`
  cursor: pointer;
`

interface Props {
  onClick: () => void
  fromPrice?: FromPrice
  dataId?: string
}

export const DealFreezeOfferBoxCard = ({
  onClick,
  fromPrice,
  dataId = DEAL_FREEZE_OFFER_BOX_CARD
}: Props) => (
  <Card
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    gap="s500"
    width="100%"
    height="100%"
    data-id={dataId}
    onClick={onClick}
  >
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      gap="s300"
    >
      <Tag variant="brand" size="sm">
        <FormattedMessageWrapper
          {...dealFreezeOfferBoxMessages.freezableDeals}
        />
      </Tag>
      <Box display="flex" flexDirection="column" gap="s100">
        <Text variant="titleM">
          <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.title} />
        </Text>
        <Text variant="bodyS" colorPath="content.neutral.secondary">
          <FormattedMessageWrapper
            {...dealFreezeOfferBoxMessages.description}
          />
        </Text>
      </Box>
    </Box>
    <Box display="flex" flexDirection="column" gap="s400">
      {fromPrice && (
        <Box display="flex" flexDirection="column">
          <Text variant="bodyS">
            <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.from} />
          </Text>
          <PriceComposition
            price={fromPrice.value}
            anchorPrice={0}
            currencyCode={fromPrice.currency}
            size="xl"
            roundingStrategy="round"
            showIndication
            showTotal={fromPrice.isTotal}
            indicationSize="bodyS"
            indicationColor={cssTheme.colors.content.neutral.primary}
            dataId={`${dataId}Price`}
          />
        </Box>
      )}
      <Button variant="tertiary" size="lg" fullWidth dataId={`${dataId}Cta`}>
        <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.viewDeals} />
      </Button>
    </Box>
  </Card>
)
